import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/ImagenPerfil`

export function subirArchivo(imagen) {
  return http.post(`${API_ENDPOINT}/Upload`, imagen)
}

export function buscarAdjuntos(idUsuario, idTipo) {
  return http.get(`${API_ENDPOINT}/BuscarAdjuntos/${idUsuario}/${idTipo}`)
}

export function buscarImagen(idUsuario = 0, idTipo) {
  return http.get(`${API_ENDPOINT}/BuscarImagen/${idUsuario}/${idTipo}`, {
    responseType: 'blob',
    meta: {
      toastMessage: 'Ocurrió un error al obtener la imagen.',
      tipoError: 'imagenPerfil'
    }
  })
}

export function BuscarImagenPorAdjunto(idUsuario, idTipo) {
  return http.get(`${API_ENDPOINT}/BuscarImagenPorAdjunto/${idUsuario}/${idTipo}`, {
    responseType: 'blob'
  })
}
